import { render, staticRenderFns } from "./ModalEditVideo.vue?vue&type=template&id=12fe2f64&scoped=true&"
import script from "./ModalEditVideo.vue?vue&type=script&lang=js&"
export * from "./ModalEditVideo.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditVideo.vue?vue&type=style&index=0&id=12fe2f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fe2f64",
  null
  
)

export default component.exports